<template>
	<b-container fluid class="h-100 d-flex flex-column p-0">
		<!-- Carte -->
		<!-- <template v-if="isMapVisible"> -->
			<!-- Barre d'outil -->
				<!-- <b-button-toolbar key-nav aria-label="Barre d'outils avec des boutons"> -->
				<!-- <b-button-group size="sm"> -->
					<!-- <b-row class="flex-grow-1 p-0 mr-0"> -->
						<!-- @todo : future liste de filtre sur la map -->
						<!-- <b-col cols="3" class="m-1">
							<b-form-select size="sm" />
						</b-col>

						<b-col /> -->

						<!-- Barre verticale -->
						<!-- <b-col cols="0" md="auto" class="border-right pl-md-1 p-md-0" />

						<b-col cols="auto" align-self="center" class="p-0 pr-1"> -->
							<!-- Bouton de rebascule sur le tableau de bord principal -->
							<!-- <b-button @click="$store.dispatch('CartoMod/ToggleIsVisible')" v-b-tooltip.hover.topright title="Afficher le tableau de bord principal" class="m-1 float-right" size="sm" variant="outline-secondary">
								<b-iconstack>
									<b-icon stacked icon="display" scale="1.65"/>
									<b-icon stacked icon="layout-wtf" scale="0.75" shift-v="1"/>
								</b-iconstack>
							</b-button>
						</b-col>
					</b-row> -->
				<!-- </b-button-group> -->
			<!-- </b-button-toolbar> -->

			<b-row class="p-0 flex-grow-1 overflow-auto no-gutters">
				<Map v-on="$listeners" :Variant="Variant" />
			</b-row>
		<!-- </template> -->
	</b-container>
</template>

<script lang="ts">
	import { Component, Vue, ProvideReactive } from 'vue-property-decorator';
	import { Getter } from 'vuex-class';
	import Map from '@/components/commons/Map.vue';

	/** 
	 * Affichage principale à l'ouverture de l'applicationM
	 * Permet de basculer entre le tableau de bord principal et la carte
	 */
	@Component({
		components: {
			Map
		}
	})
	export default class MainMap extends Vue {
		@Getter('CartoMod/GetIsVisible')
		private isMapVisible!: boolean;

		/** Variant de couleur à appliquer sur les tableaux de bord */
        @ProvideReactive()
        private Variant: string = "tertiary";

        //#region Affichage map
        /** Indique si la map est affiché ou bien le MainDashoards */
        // private isMapVisible: boolean = false;
        //#endregion Affichage map
	}
</script>

<style scoped>
</style>